/* eslint no-eval: 0 */

import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import React, { Fragment, useEffect, useState } from 'react';
//style={{ color: 'purple' }}
import { Datagrid, FunctionField, List, ShowButton, TextField } from 'react-admin';
import ResetViewsButton from '../bulk/ResetViewsButton';
import FormDialogPayement from '../dialog/FormDialogPayement.js';
import FiltreColis from '../filtres/FiltreColis';
//import ExportAgExp from './ExportAgExp';
import PostPagination from '../paginations/pagination';
import { has_role,PhoneExpField,PhoneDestField} from '../references';
import { isSelectable } from '../references.js';
import rowStyleChargement from '../styles/rowStyleChargement';

const  ListColis=(props)=>{

    const [fullname, setFullname] = useState('');
    const [reste_a_payer, setReste_a_payer] = useState();
    const [roles, setRole] = useState();

    useEffect(() => {
        setFullname(localStorage.getItem('fullname'));
        setRole(localStorage.getItem('roles'));
    }, []);

 return(
        <List {...props} 
                bulkActionButtons={<PostBulkActionButtons  roles={roles}/>}
                filters={<FiltreColis />} 
                filterDefaultValues={ {"camp_type":"AERIEN"}} 
                pagination={<PostPagination />}
                sort={{ field: 'id', order: 'DESC' }}
                title={'Campagne ayant des colis deplacés - '+fullname}
                empty={false}
            >
                
            <Datagrid rowStyle={rowStyleChargement} isRowSelectable={record =>isSelectable(roles,record.chge_user_id,record.camp_type) } >
                <TextField source="numCodeEtiq" label="Code" style={{ color: 'purple'  }} sortBy="numCodeEtiq"/>
                <TextField source="message" multiline  component="pre" label="Message" />
                <PhoneExpField source="telephone1_exp" label="Expéditeur" />
                <PhoneDestField source="telephone1_dst" label="Destinateur"  />
                {has_role(roles,'ROLE_MANAGER') ? null: 
                    <FunctionField render={record => <ShowButton  basePath={'/aerien/'+record.ord_id+'/show'} label="Afficher" record={record} /> } />
                }
                <FunctionField render={record =>(record.reste_a_payer) ?  <FormDialogPayement from="list" for='livraison' data={record}/> :  null } />
                <FunctionField render={record => setReste_a_payer(record.reste_a_payer) } />
            </Datagrid>
        </List>
       ) ;
    };

export default ListColis;

const PostBulkActionButtons = props => (
    <Fragment>
         <ResetViewsButton label={has_role(props.roles,'ROLE_MANAGER') ? 'Annuler chargement':'Chargé'}
            title={has_role(props.roles,'ROLE_MANAGER') ? 'Annuler chargement des colis séléctionnés':'Chargement des colis séléctionnés'}
            content={has_role(props.roles,'ROLE_MANAGER') ?'Voulez vous annuler le chargement des colis séléctionnés ?':'Voulez vous charger les colis séléctionnés ?'} {...props} 
            url={process.env.REACT_APP_URL +'/etiq/updateChgEtiqAerienMaritime?ids=' + props.selectedIds}
            startIcon={<HourglassEmptyIcon/>}
        />
    </Fragment>
);
